<template>
    <nav class="dk-bottom-nav">
        <router-link to="/dashboard" class="dk-bnav-item">
            <span class="dk-bnav-icon">🏠</span>
            <span>Home</span>
        </router-link>
        <router-link to="/prenotazioni" class="dk-bnav-item">
            <span class="dk-bnav-icon">📅</span>
            <span class="dk-bnav-badge" v-if="nPrenotazioni > 0">{{nPrenotazioni}}</span>
            <span>Prenota</span>
        </router-link>
        <router-link to="/shop" class="dk-bnav-item">
            <span class="dk-bnav-icon">🛒</span>
            <span class="dk-bnav-badge" v-if="nCarrello > 0">{{nCarrello}}</span>
            <span>Shop</span>
        </router-link>
        <router-link to="/ricevute" class="dk-bnav-item">
            <span class="dk-bnav-icon">🧾</span>
            <span>Ricevute</span>
        </router-link>
        <button class="dk-bnav-item" @click="$emit('apri-profilo')">
            <span class="dk-bnav-icon">👤</span>
            <span>Profilo</span>
        </button>
    </nav>
</template>

<script>
export default {
    name: 'BottomNav',
    emits: ['apri-profilo'],
    computed: {
        nPrenotazioni() {
            return this.$root.homeStats?.PRENOTAZIONI?.length || 0;
        },
        nCarrello() {
            return this.$root.homeStats?.CARRELLO?.ITEMS?.length || 0;
        },
    },
}
</script>
